<ng-container *ngIf="jediniceURestauracijiViewState" ntapDynamicFormProvider>
    <ng-container ntapFilterViewProvider [viewName]="jediniceURestauracijiViewName"
        [viewState]="jediniceURestauracijiViewStateFilter">
        <ng-container ntapListViewProvider [viewName]="jediniceURestauracijiViewName"
            [viewState]="jediniceURestauracijiViewState">
            <ntap-dynamic [compId]="LIST_COMP_ID"></ntap-dynamic>
        </ng-container>
    </ng-container>
</ng-container>
<ng-container *ngIf="pojavniObliciURestauracijiViewState" ntapDynamicFormProvider>
    <ng-container ntapFilterViewProvider [viewName]="pojavniObliciURestauracijiViewName"
        [viewState]="pojavniObliciURestauracijiViewStateFilter">
        <ng-container ntapListViewProvider [viewName]="pojavniObliciURestauracijiViewName"
            [viewState]="pojavniObliciURestauracijiViewState">
            <ntap-dynamic [compId]="LIST_COMP_ID"></ntap-dynamic>
        </ng-container>
    </ng-container>
</ng-container>
<ng-container *ngIf="fizickiObjektiURestauracijiViewState" ntapDynamicFormProvider>
    <ng-container ntapFilterViewProvider [viewName]="fizickiObjektiURestauracijiViewName"
        [viewState]="fizickiObjektiURestauracijiViewStateFilter">
        <ng-container ntapListViewProvider [viewName]="fizickiObjektiURestauracijiViewName"
            [viewState]="fizickiObjektiURestauracijiViewState">
            <ntap-dynamic [compId]="LIST_COMP_ID"></ntap-dynamic>
        </ng-container>
    </ng-container>
</ng-container>